import React from 'react';
import { motion } from 'framer-motion';
import { RevealOnScroll } from '../ui/RevealOnScroll';
import { TextLink } from '../ui/TextLink';
const projects = [{
  id: '01',
  name: 'THE STAG RESERVE',
  desc: 'A Hill Country retreat.\nWalnut, leather, midnight blue.',
  image: 'https://cdn.magicpatterns.com/uploads/9SLdDSsbnaZNGcpwaG83jy/spaces-design1.jpg'
}, {
  id: '02',
  name: 'THE MUSE',
  desc: "An artist's sanctuary.\nPlaster, linen, morning light.",
  image: 'https://cdn.magicpatterns.com/uploads/ff5wMLJYifCXSf2cXCo7Gy/spaces-design3.jpg'
}, {
  id: '03',
  name: "THE WRITER'S ROOM",
  desc: 'A quiet place to think.\nOak, parchment, aged brass.',
  image: 'https://cdn.magicpatterns.com/uploads/29V1yWBu2GT45RrC8Rnawo/spaces-design2.jpg'
}, {
  id: '04',
  name: 'SOHO HOME',
  desc: 'Urban refuge.\nVelvet, steel, deep charcoal.',
  image: 'https://cdn.magicpatterns.com/uploads/9SLdDSsbnaZNGcpwaG83jy/spaces-design1.jpg'
}, {
  id: '05',
  name: 'THE QUIET HOUSE',
  desc: 'A study in restraint.\nCashmere, stone, silence.',
  image: 'https://cdn.magicpatterns.com/uploads/dXESK41oaqD19KNXTy2tsJ/spaces-image2.jpg'
}];
export function Resonance() {
  return <section id="resonance" className="bg-parchment py-24 md:py-32 overflow-hidden" data-id="element-178">
      <div className="container mx-auto px-6 mb-16 md:mb-24" data-id="element-179">
        <RevealOnScroll data-id="element-180">
          <p className="font-mono text-[12px] tracking-[0.2em] uppercase text-ink mb-6" data-id="element-181">
            CHAPTER THREE. RESONANCE.
          </p>
          <div className="md:pl-12 lg:pl-24" data-id="element-182">
            <h2 className="font-serif italic text-ink text-4xl md:text-[56px] max-w-[700px] mb-6" data-id="element-183">
              Spaces that stayed with us.
            </h2>
            <p className="font-mono text-[14px] text-ink/80 max-w-[480px]" data-id="element-184">
              A small selection of recent works. Each one a story we were
              trusted to tell.
            </p>
          </div>
        </RevealOnScroll>
      </div>

      <div className="w-full overflow-hidden pb-12 marquee-mask" data-id="element-185">
        <motion.div className="flex gap-6 md:gap-12 w-max" animate={{
        x: ['0%', '-50%']
      }} transition={{
        duration: 60,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-186">
          {[...projects, ...projects].map((project, index) => <div key={`${project.id}-${index}`} className="w-[85vw] md:w-[400px] lg:w-[480px] group cursor-pointer flex-shrink-0" data-id="element-187">
              <div className="relative overflow-hidden aspect-[3/4] mb-6 bg-ink/5" data-id="element-188">
                <img src={project.image} alt={project.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" data-id="element-189" />
                <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/20 transition-colors duration-500 flex items-center justify-center" data-id="element-190">
                  <span className="font-serif italic text-brass text-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-191">
                    read
                  </span>
                </div>
              </div>

              <div className="font-mono text-ink text-[12px] leading-[1.8]" data-id="element-192">
                <div className="flex items-center gap-4 mb-4" data-id="element-193">
                  <span data-id="element-194">
                    NO. {project.id} / {project.name}
                  </span>
                  <span className="flex-grow h-[1px] bg-ink/20" data-id="element-195"></span>
                </div>
                <p className="whitespace-pre-wrap opacity-80" data-id="element-196">{project.desc}</p>
              </div>
            </div>)}
        </motion.div>
      </div>

      <div className="container mx-auto px-6 mt-12 flex justify-center" data-id="element-197">
        <RevealOnScroll data-id="element-198">
          <TextLink href="#library" className="text-ink" underlineColor="border-ink" data-id="element-199">
            view the full library &rarr;
          </TextLink>
        </RevealOnScroll>
      </div>
    </section>;
}